import React from 'react';
import Label from '../Label';
import { hubspotKey } from '../../services/hubspotSync';

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  /** HubSpot's options for this dropdown; empty when HubSpot could not be asked. */
  options: string[];
  disabled?: boolean;
}

/**
 * Which HubSpot dropdown option a partner or warehouse location stands for. HubSpot
 * is where ops assign couriers and warehouses, and an order is given to whatever is
 * linked to the option HubSpot names, so the link has to be the option itself --
 * picked from HubSpot's list, not typed. When the list cannot be loaded the name
 * can be typed instead, exactly as HubSpot shows it; the API checks it against
 * HubSpot when it can.
 */
export default function HubspotNameField({ id, label, value, onChange, options, disabled }: Props) {
  const known = options.some((o) => hubspotKey(o) === hubspotKey(value));
  return (
    <div className="logistics-modal__field">
      <Label htmlFor={id}>{label}</Label>
      {options.length > 0 ? (
        <select
          className="logistics-modal__select"
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        >
          <option value="">— Not linked to HubSpot —</option>
          {value && !known && <option value={value}>{value} (not in HubSpot’s list)</option>}
          {options.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
      ) : (
        <>
          <input
            className="logistics-modal__input"
            type="text"
            id={id}
            maxLength={120}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
          />
          <p className="logistics-modal__hint">
            HubSpot’s list could not be loaded. Type the name exactly as HubSpot shows it, or leave it blank.
          </p>
        </>
      )}
    </div>
  );
}
